export const WP_GENERATED_ROUTE_SCOPE_POLICY_VERSION = "wp-r5-phase3-route-policy-v1";
export const GENERATED_ROUTE_SCOPE_POLICY = [
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/assets",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/assets/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/assets/topology",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/client/devices",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/client/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/compliance/assessments",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/compliance/cmmc/assessments/{assessment_id}/readiness",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/compliance/cmmc/readiness",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/compliance/remediation",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/device-recovery/requests",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/device-status/alerts",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/device-status/devices",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/device-status/settings",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/device-status/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "device_uuid",
      "status"
    ],
    "pathTemplate": "/edr/actions",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "device_uuid"
    ],
    "pathTemplate": "/edr/evidence",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/endpoint-inventory/devices",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/endpoint-inventory/devices/{device_uuid}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/endpoint-inventory/devices/{device_uuid}/applications",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/endpoint-inventory/submissions",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/endpoint-inventory/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/enrollment-keys",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/grc/exceptions",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/grc/policies",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/grc/vendors",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/access-decisions",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/identity/access-reviews",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/access-reviews/{review_id}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/device-posture",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/identity/identities",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/identities/{identity_id}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/identity/privileged-access",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/roles",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/identity/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "severity",
      "status"
    ],
    "pathTemplate": "/incidents",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "device_uuid",
      "severity"
    ],
    "pathTemplate": "/logs",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/network-protection/block-requests",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/network-protection/block-requests/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/network-protection/detections",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/network-protection/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/active-scope",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/dashboard",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/engagements",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/findings",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/profiles",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/remediation",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/report",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/report/pdf",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/scans",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/pentest/targets",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-assignment/acknowledgments",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-assignment/assignments",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-assignment/effective/{device_uuid}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-assignment/groups",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-enforcement/states",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-enforcement/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-enforcement/unlocks",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-platform/capabilities",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-platform/reports",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/policy-platform/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/remote-uninstall/requests",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/reporting/archive",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reporting/archive/{report_id}/download",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reporting/executive-summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reporting/executive-summary.pdf",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/reporting/incidents.csv",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reporting/incidents/{incident_id}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reporting/incidents/{incident_id}.pdf",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/reports/executive",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/risk-register",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/runtime-telemetry/batches",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/runtime-telemetry/devices",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/runtime-telemetry/devices/{device_uuid}",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "device_uuid"
    ],
    "pathTemplate": "/runtime-telemetry/security-events",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/runtime-telemetry/summary",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "status"
    ],
    "pathTemplate": "/security-alerts",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "status"
    ],
    "pathTemplate": "/siem/detections/matches",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "device_uuid",
      "severity"
    ],
    "pathTemplate": "/siem/events",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "status"
    ],
    "pathTemplate": "/soar/runs",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "status"
    ],
    "pathTemplate": "/soc/analysts",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "device_uuid"
    ],
    "pathTemplate": "/telemetry-governance/delivery-events",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/telemetry-governance/delivery-status",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "device_uuid"
    ],
    "pathTemplate": "/telemetry-governance/query",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/telemetry-governance/retention-audit",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/telemetry-governance/retention-policy",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/telemetry-governance/retention-runs",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "status"
    ],
    "pathTemplate": "/threat-hunting/hunts",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "severity"
    ],
    "pathTemplate": "/threat-intel/indicators",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "severity"
    ],
    "pathTemplate": "/threat-intel/indicators/search",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "status"
    ],
    "pathTemplate": "/threat-intel/matches",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id",
      "severity",
      "status"
    ],
    "pathTemplate": "/ueba/anomalies",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/ueba/entities",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/ueba/rules",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/vulnerabilities/",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/vulnerabilities/report",
    "required": []
  },
  {
    "method": "GET",
    "params": [
      "company_id"
    ],
    "pathTemplate": "/vulnerabilities/report/export",
    "required": []
  }
];
